<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',

}
</script>

<style>
body {
  font-family: Microsoft JhengHei, Arial, Helvetica Neue, Helvetica, sans-serif;
  background: #f7f7f7;
  font-size: 14px;
  min-width: 320px;
}

* {
  margin: 0;
  padding: 0;
  outline: none;
}

ul,
li {
  list-style: none;
}

a {
  text-decoration: none;
}

img {
  border: none;
}
.el-image-viewer__close {
  color: #fff;
}
.alertbox {
  display: flex;
  align-items: center;
}
.alert-error.el-icon-error {
  font-size: 30px;
  color: #f6625e;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.el-select {
  display: block !important;
  flex: 1;
}
.currency-icon {
  width: 20px;
  height: 20px;
}
.img-text-box span {
  margin: 0 5px;
}

.unlink {
  text-decoration: line-through;
  color: #999;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.mb15{
  margin-bottom:15px;
}

.mt15{
  margin-top:15px;
}

.mr15{
  margin-right:15px;
}

.ml15{
  margin-left:15px;
}

/*  去除input:number默認樣式 */
input[type=number] {
  -moz-appearance:textfield;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.pdf-btn-box {
  border-radius: 5px;
  position: relative;
  margin-right: 15px;
}
.pdf-btn-box img {
  width: 108px;
  height: 108px;
}
.pdf-btn-box .del-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 10;
}

.pdf-btn-box .del-btn i {
  font-size: 18px !important;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.pdf-btn-box .del-btn i:hover {
  cursor: pointer;
  background-color: rgba(255, 0, 0, 0.9);
}

.pdf-btn-box .pdf-title {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px !important;
  line-height: 30px;
  width: 100%;
  text-align: center;
}
.riskicon_san {
  display: inline-block;
  padding: 2px 5px;
  color: #fff;
  background: #f00;
}

.riskicon_pep {
  display: inline-block;
  padding: 2px 5px;
  color: #fff;
  background: yellowgreen;
}

.riskicon_other {
  display: inline-block;
  padding: 2px 5px;
  color: #fff;
  background: skyblue;
}
.showdowjones_row.imggroup {
  display: block;
}
.showdowjones_row.imggroup > div {
  display: flex;
  padding: 10px 0;
  flex-flow: wrap;
}
.showdowjones_row.imggroup > div > div {
  margin: 0 5px;
}
.showdowjones_row.imggroup img {
  width: 50px;
}
.showdowjones_row {
  padding: 10px 0;
  border-bottom: 1px solid #999;
}
.showdowjones_row.flex {
  display: flex;
}
.showdowjones_row.flex > div:first-child {
  margin-right: 10px;
}
.dowjones_pdf {
  margin-top: 20px;
  display: flex;
}
.dowjones_pdf a {
  color: #409eff;
  background: #ecf5ff;
  border-color: #b3d8ff;
  display: block;
  padding: 12px 20px;
  border: 1px solid #b3d8ff;
}
.showdowjones_pdf {
  display: flex;
  justify-content: center;
}
.dowjones-logo {
  width: 300px;
  margin-bottom: 20px;
}

.dowjones-logo > img {
  width: 100%;
  height: 100%;
}

@media screen and (min-width: 1024px) {
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #333;
  }

  ::-webkit-scrollbar-corner {
    background: #179a16;
  }
}

.mr10 {
  margin-right: 10px;
}

.mr15 {
  margin-right: 15px;
}

.pagemain {
}

.mainheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.phonecel {
  display: none;
}

.flexbox {
  width: 50%;
}
.mm-phone-item {
  margin: 10px 0;
}
.mm-flex {
  display: flex;
  align-items: center;
}
.zhehe {
  margin-left: 10px;
}
.el-card__body {
  padding: 20px !important;
}
.el-card {
  margin-bottom: 20px !important;
}
@media screen and (max-width: 1024px) {
  table.el-table__footer {
    display: flex !important;
    width: 100% !important;
  }
  table.el-table__body {
    width: 100% !important;
    display: flex !important;
  }
  table.el-table__body tbody {
    width: 100%;
  }
  table.el-table__footer tbody {
    width: 100% !important;
    display: flex;
  }

  table.el-table__footer tr {
    flex: 1 100% !important;
    display: flex;
    justify-content: space-between;
  }

  table.el-table__footer td {
    width: 100%;
    border-right: 0 !important;
    text-align: right;
  }
  .headermso .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 150px;
  }
  .headermso .el-input__suffix {
    position: absolute;
    right: 0px;
    top: 5px;
  }
  .headermso .is-focus .el-input__suffix {
    position: absolute;
    top: -5px;
  }
  .mm-select-ico {
    top: 38px !important;
  }
  .mm-tabs-content {
    padding: 10px 5px !important;
  }
  .el-card__body {
    padding: 5px !important;
  }
  .mm-text-right {
    text-align: right;
  }
  .mm-flex {
    display: flex;
    align-items: center;
  }
  .zhehe {
    margin-left: 10px;
  }
  .downexcel {
    padding-top: 20px;
    text-align: center;
  }

  .flexbox {
    width: 100%;
  }

  .flexbox.bumenname {
    width: auto;
  }

  .mm-col {
    flex: 1 1 100% !important;
  }

  .mm-col:nth-child(even) > .mm-item > label {
    text-align: left !important;
  }

  .mm-label {
    padding-left: 0 !important;
    width: auto !important;
  }

  .el-dialog__body {
    padding: 10px 5px !important;
  }

  .mainheader {
    display: block;
  }

  span.el-pagination__jump {
    display: none !important;
  }

  .radio-group-title {
    display: none;
  }

  span.el-radio-button__inner {
    padding: 8px 10px;
  }

  table.el-table__body {
    width: 100% !important;
    display: flex;
  }

  .el-table tr {
    display: flex;
    flex: 1 1 100%;
    flex-wrap: wrap;
    margin: 20px 10px;
    border: 1px solid #f5f7fa;
    border-radius: 10px;
  }

  .el-table tr:nth-child(even) {
    background: #f5f7fa;
  }

  .el-table__body td {
    flex: 1 1 100%;
    border-right: 0 !important;
  }

  .el-table__body td:last-child {
    border-bottom: none !important;
  }

  .el-table__row .cell {
    display: flex;
    justify-content: space-between;
  }

  .el-table__header-wrapper {
    display: none;
  }

  .phonecel {
    display: block;
  }

  .page-bottom {
    display: block !important;
  }

  .pagebox {
    display: flex;
    justify-content: center;
  }

  .el-form-item {
    display: block;
    justify-content: space-between;
    align-items: center;
  }

  .elselect .el-input__suffix {
    position: absolute !important;
    top: 18px !important;
  }

  .form-group-content {
    padding: 10px !important;
  }

  .mm-row {
    padding: 5px !important;
    width: auto !important;
    align-items: center !important;
  }

  .el-form-item:before {
    display: none !important;
  }

  .el-form-item:after {
    display: none !important;
  }

  .el-form-item__label {
    white-space: nowrap;
  }
  .el-form-item__content {
    margin-left: 10px !important;
  }
  .el-form-item__content:before {
    display: none !important;
  }
  .buyaofloat label {
    float: inherit;
  }
  .zhehe label {
    float: inherit;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-button {
    padding: 8px 10px !important;
  }

  .form-isheader-group-content {
    padding: 10px 5px !important;
  }

  .el-input--suffix .el-input__inner {
    padding: 0 25px !important;
  }

  .el-table__empty-block {
    width: 100% !important;
  }
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 20px;
  font-weight: 800;
}

.page-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.search .mm-row {
  margin-bottom: 20px;
}

.mm-row {
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.mm-row:last-child {
  margin-bottom: 0;
}

.mm-col {
  flex: 1;
}

.mm-empty {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mm-col:nth-child(even) > .mm-item > label {
  text-align: center;
}

.mustlabel {
  position: absolute;
  left: 0px;
  top: 2px;
  color: #f00;
}

.mm-item {
  display: flex;
  flex: 1;
  align-items: center;
}

.mmline {
  padding: 0 10px;
  display: flex;
  align-items: center;
}

.mm-label {
  padding-left: 10px;
  white-space: nowrap;
  margin-right: 10px;
  color: #606266;
  flex: 0 0 70px;
  text-align: left;
  line-height: 40px;
  position: relative;
}

.mm-label-110 {
  padding-left: 10px;
  white-space: nowrap;
  margin-right: 10px;
  color: #606266;
  flex: 0 0 100px;
  text-align: left;
  line-height: 40px;
  position: relative;
}

.mm-submitbox {
  display: flex;
  justify-content: flex-start;
}

.mm-tablebox {
  min-width: auto;
}

.mm-table-body {
  overflow: auto;
}

.mm-table-header {
  overflow: auto;
}

.mm-tab-hedaer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.mm-switch {
  height: 40px;
  display: flex;
  align-items: center;
}

.form-isheader-group-content {
  padding: 20px;
}

.group-title {
  height: 60px;
  background: #fafafa;
  padding: 0 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
}

.group-sub-title {
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.form-isheader-group {
  border: 1px solid #ebeef5;
  flex: 1;
  margin-bottom: 20px;
}

.form-isheader-group:last-child {
  margin-bottom: 0px;
}

.page-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-group-content {
  border: 1px solid #ebeef5;
  padding: 20px;
  margin: 15px 0;
  min-height: 160px;
}

.radio-group-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mm-radiogroup {
  display: flex;
  align-items: center;
}

.mm-radiogroup-title {
  margin-right: 10px;
}

.page-back svg {
  font-size: 30px;
  fill: #66b1ff;
  cursor: pointer;
}

.flex-empty {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nodata {
}

.mb20 {
  margin-bottom: 20px;
}

.flex-start{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.mm-tabs {
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  min-height: 200px;
}

.mm-tabs-card {
  display: flex;
  background: #f5f7fa;
  border-radius: 2px;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
  position: relative;
}

.mm-tabsulbox {
  position: relative;
  padding: 0 15px;
  background: #f5f7fa;
  overflow: hidden;
}

.tabsleftico {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.tabsrightico {
  z-index: 1;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.mm-tabs-card > li {
  white-space: nowrap;
  position: relative;
  top: 1px;
  border: 1px solid transparent;
  padding: 0 20px;
  cursor: pointer;
  display: flex;
  line-height: 40px;
  height: 40px;
  color: #909399;
  border-radius: 2px;
  user-select: none;
}

.mm-tabs-card > li:hover {
  color: #409eff;
}

.mm-tabs-card > li.active {
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  background: #fff;
  color: #409eff;
}

.mm-tabs-card > li:first-child.active {
  border-left: 1px solid transparent;
}

.mm-tabs-content {
  padding: 20px;
}

.mm-mr15 {
  margin-right: 15px;
}

.mm-ml15 {
  margin-left: 15px;
}

.text-red {
  color: red;
}

.text-orange {
  color: orange;
}

.text-green {
  color: green;
}

.text-gray {
  color: gray;
}

.text-gold {
  color: gold;
}

/** 修改disabled 時的字體顔色**/
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #606266 !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #606266 !important;
}

.el-input.is-disabled .el-input__inner {
  color: #606266 !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #606266 !important;
}

.el-textarea.is-disabled .el-textarea__inner {
  opacity: 1;
  color: #606266;
  -webkit-text-fill-color: #606266;
}

.el-radio-button__orig-radio:disabled + .el-radio-button__inner {
  color: #606266 !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #606266 !important;
}
.select-red .el-input__inner {
  color: #f00 !important;
}
.select-orange .el-input__inner {
  color: orange !important;
}
.select-green .el-input__inner {
  color: green !important;
}
.select-gold .el-input__inner {
  color: gold!important;
}
.select-gray .el-input__inner {
  color: gray!important;
}
</style>
